import { render } from "./index.vue?vue&type=template&id=3aa90200&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=3aa90200&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.4.27_vue@3.2.36_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa90200"]])

export default __exports__